(function () {
  'use strict';

  var CART_ADD_PATTERN = /\/cart\/add/;
  var DEBOUNCE_MS = 150;
  var DRAWER_DELAY_MS = 400;
  var pendingTimer = null;

  function isCartAddRequest(url) {
    var str = typeof url === 'string' ? url : (url instanceof Request ? url.url : '');
    return CART_ADD_PATTERN.test(str);
  }

  function isThemeRequest(options) {
    if (!options || !options.headers) return false;
    if (options.headers instanceof Headers) {
      return options.headers.get('X-Requested-With') === 'XMLHttpRequest';
    }
    return options.headers['X-Requested-With'] === 'XMLHttpRequest';
  }

  function onThirdPartyCartAdd(productTitle) {
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () {
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));

      if (typeof theme === 'undefined' || !theme.settings) return;
      var action = theme.settings.afterAddToCart;

      if (action === 'drawer') {
        var drawer = document.querySelector('.js-cart-drawer');
        if (drawer) {
          setTimeout(function () { drawer.open(null); }, DRAWER_DELAY_MS);
        }
      } else if (action === 'notification') {
        var tpl = document.getElementById('AddedNotification');
        if (tpl) {
          var el = tpl.content.firstElementChild.cloneNode(true);
          el.dataset.productTitle = productTitle || '';
          var container = document.querySelector('.pageheader--sticky') || document.body;
          container.appendChild(el);
        }
      }
    }, DEBOUNCE_MS);
  }

  function parseProductTitle(data) {
    if (!data) return '';
    if (data.product_title) return data.product_title;
    if (data.items && data.items.length && data.items[0].product_title) {
      return data.items[0].product_title;
    }
    return '';
  }

  var nativeFetch = window.fetch;

  window.fetch = function (url, options) {
    var shouldIntercept = isCartAddRequest(url) && !isThemeRequest(options);
    var promise = nativeFetch.apply(this, arguments);

    if (shouldIntercept) {
      promise.then(function (response) {
        if (!response.ok) return;
        response.clone().json().then(function (data) {
          onThirdPartyCartAdd(parseProductTitle(data));
        }).catch(function () {
          onThirdPartyCartAdd('');
        });
      }).catch(function () {});
    }

    return promise;
  };

  var nativeXHROpen = XMLHttpRequest.prototype.open;
  var nativeXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._cartIntercept = isCartAddRequest(url);
    return nativeXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this._cartIntercept) {
      var xhr = this;
      xhr.addEventListener('load', function () {
        if (xhr.status < 200 || xhr.status >= 300) return;
        var title = '';
        try {
          var data = JSON.parse(xhr.responseText);
          title = parseProductTitle(data);
        } catch (e) {}
        onThirdPartyCartAdd(title);
      });
    }
    return nativeXHRSend.apply(this, arguments);
  };
})();

(function () {
  'use strict';

  function fixSwatchKingPrice(container) {
    if (!container.querySelector('.product-price__item')) return;

    var saleEl = container.querySelector('.product-price__amount--on-sale');
    var compareEl = container.querySelector('.product-price__compare');

    var currentPrice, comparePrice, isOnSale;

    if (saleEl && compareEl) {
      currentPrice = saleEl.textContent.trim();
      comparePrice = compareEl.textContent.trim();
      isOnSale = true;
    } else {
      var amounts = container.querySelectorAll('.product-price__amount');
      var visible = null;
      for (var i = 0; i < amounts.length; i++) {
        var s = amounts[i].getAttribute('style') || '';
        if (s.indexOf('display:none') === -1 && s.indexOf('display: none') === -1) {
          visible = amounts[i];
          break;
        }
      }
      if (!visible && amounts.length) visible = amounts[0];
      if (!visible) return;

      currentPrice = visible.textContent.trim();
      comparePrice = null;
      isOnSale = false;
    }

    var strings = (typeof theme !== 'undefined' && theme.strings) || {};
    var salePriceLabel = strings.salePrice || '';
    var regularPriceLabel = strings.regularPrice || '';
    var saleLabel = strings.saleLabel || '';
    var cls = 'price' + (isOnSale ? ' price--on-sale' : '');
    var h = '<div class="' + cls + '">';
    h += '<div class="price__default">';
    h += '<span class="price__current">';
    h += '<span class="visually-hidden js-label">' + (isOnSale ? salePriceLabel : regularPriceLabel) + '</span>';
    h += '<span class="js-value">' + currentPrice + '</span>';
    h += '</span>';

    if (isOnSale && comparePrice) {
      h += '<span class="price__was">';
      h += '<span class="visually-hidden js-label">' + regularPriceLabel + '</span>';
      h += '<span class="js-value">' + comparePrice + '</span>';
      h += '</span>';
    }

    h += '</div>';

    if (isOnSale && saleLabel) {
      h += '<span class="price-label price-label--sale">' + saleLabel + '</span>';
    }

    h += '</div>';

    container.innerHTML = h;
  }

  function observePriceContainers() {
    var containers = document.querySelectorAll('.product-price');
    for (var i = 0; i < containers.length; i++) {
      (function (el) {
        if (el._skObserver) return;

        fixSwatchKingPrice(el);

        var obs = new MutationObserver(function () {
          obs.disconnect();
          fixSwatchKingPrice(el);
          obs.observe(el, { childList: true, subtree: true });
        });
        obs.observe(el, { childList: true, subtree: true });
        el._skObserver = obs;
      })(containers[i]);
    }
  }

  function init() {
    observePriceContainers();

    var debounce = null;
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(observePriceContainers, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  'use strict';

  function getHandle(url) {
    if (!url) return '';
    try { url = new URL(url, location.origin).pathname; }
    catch (e) { url = url.split('?')[0].split('#')[0]; }
    var m = url.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  }

  function syncSelection(select) {
    var curHandle = getHandle(location.href);
    if (!curHandle) return;

    for (var i = 0; i < select.options.length; i++) {
      var optHandle = getHandle(select.options[i].getAttribute('data-url'));
      if (optHandle && optHandle === curHandle) {
        select.selectedIndex = i;
        return;
      }
    }

    for (var i = 0; i < select.options.length; i++) {
      var val = (select.options[i].value || '').toLowerCase();
      if (val && curHandle.indexOf(val) !== -1) {
        select.selectedIndex = i;
        return;
      }
    }
  }

  function enhanceUI(wrapper, select) {
    if (wrapper.getAttribute('data-sumthincs-brand-enhanced') === 'true') return;
    wrapper.setAttribute('data-sumthincs-brand-enhanced', 'true');

    if (!wrapper.querySelector('.brand-dropdown__arrow')) {
      var arrow = document.createElement('span');
      arrow.className = 'brand-dropdown__arrow';
      arrow.innerHTML =
        '<svg class="brand-dropdown__icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg>';
      wrapper.appendChild(arrow);
    }

    if (select.getAttribute('data-sumthincs-brand-select-bound') === 'true') return;
    select.setAttribute('data-sumthincs-brand-select-bound', 'true');

    select.addEventListener('focus', function () {
      wrapper.classList.add('brand-dropdown--open');
    });
    select.addEventListener('blur', function () {
      wrapper.classList.remove('brand-dropdown--open');
    });
    select.addEventListener('mousedown', function () {
      wrapper.classList.toggle('brand-dropdown--open');
    });
    select.addEventListener('change', function () {
      wrapper.classList.remove('brand-dropdown--open');
      if (select.classList.contains('js-brand-select')) {
        var url = select.options[select.selectedIndex].getAttribute('data-url');
        if (url) window.location.href = url;
      }
    });
  }

  function initBrandDropdowns() {
    document.querySelectorAll('.brand-dropdown').forEach(function (wrapper) {
      var select =
        wrapper.querySelector('select.js-brand-select') ||
        wrapper.querySelector('select.js-model-select') ||
        wrapper.querySelector('select[id^="brandSelect"]') ||
        wrapper.querySelector('select[name="brand"]') ||
        wrapper.querySelector('select[name="model"]') ||
        wrapper.querySelector('select');
      if (!select) return;

      if (select.classList.contains('js-brand-select')) {
        syncSelection(select);
      }

      enhanceUI(wrapper, select);
    });
  }

  window.sumthincsInitBrandDropdowns = initBrandDropdowns;
  window.sumthincsEnhanceBrandDropdown = enhanceUI;
  window.sumthincsSyncBrandSelection = syncSelection;
  window.sumthincsGetProductHandle = getHandle;

  function init() {
    initBrandDropdowns();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 0);
    });
  } else {
    setTimeout(init, 0);
  }
})();

(function () {
  'use strict';

  var debounceTimer = null;
  var retryTimer = null;
  var retryCount = 0;
  var MAX_RETRIES = 40;
  var MAIN_SWATCH_SELECTOR = '.section-main-product variant-swatch-king, product-form variant-swatch-king, .section-main-product product-swatch-king, product-form product-swatch-king';
  var CM_OPTIONS_SELECTOR = '#cm-options, .cm-options';
  // Bundle ("Ekstra Ürünler") app block — used as the fallback anchor when no
  // Swatch King is present, so the customizer ends up right under the model
  // selection and the bundle stays directly above the add-to-cart button.
  var BUNDLE_SELECTOR = '[id^="shopify-block-"][id*="mce_upsell_combo_bundle"], mce-upsell-atc';

  function getMainProductScope(el) {
    return el.closest('.section-main-product') || el.closest('product-form') || document;
  }

  function getMainProductRoot() {
    return document.querySelector('.section-main-product') || document.querySelector('product-form') || document;
  }

  function getInsertionTarget(swatchKing) {
    return swatchKing.closest('[id^="shopify-block-"], .shopify-block, .shopify-app-block') || swatchKing;
  }

  function getCmOptions(scope) {
    var scopedOptions = scope.querySelectorAll(CM_OPTIONS_SELECTOR);
    if (scopedOptions.length) return scopedOptions;

    var allSwatches = document.querySelectorAll(MAIN_SWATCH_SELECTOR);
    var allOptions = document.querySelectorAll(CM_OPTIONS_SELECTOR);

    if (allSwatches.length === 1 && allOptions.length === 1) {
      return allOptions;
    }

    return [];
  }

  function connectOptionsToForm(cmOptions, insertionTarget) {
    var sourceForm = cmOptions.closest('form');
    var productForm = insertionTarget.closest('product-form');
    var targetForm = sourceForm || (productForm && productForm.querySelector('form.js-product-form'));

    if (!targetForm) return;

    var formId = targetForm.getAttribute('id');
    if (!formId) {
      formId = 'product-form-' + Date.now();
      targetForm.setAttribute('id', formId);
    }

    cmOptions.querySelectorAll('button, fieldset, input, object, output, select, textarea').forEach(function (field) {
      field.setAttribute('form', formId);
    });
  }

  function moveCmOptionsForSwatch(swatchKing) {
    var scope = getMainProductScope(swatchKing);
    var insertionTarget = getInsertionTarget(swatchKing);
    var moved = false;

    getCmOptions(scope).forEach(function (cmOptions) {
      if (cmOptions === insertionTarget || cmOptions.contains(insertionTarget)) return;
      if (cmOptions.parentNode === insertionTarget.parentNode && cmOptions.nextElementSibling === insertionTarget) return;

      connectOptionsToForm(cmOptions, insertionTarget);
      insertionTarget.parentNode.insertBefore(cmOptions, insertionTarget);
      moved = true;
    });

    return moved;
  }

  // Preferred anchor: the quantity selector inside the main product buy-buttons
  // form. Returns the node the customizer should be inserted before, or null
  // when this product has no quantity selector (setting turned off).
  function getQuantityAnchor(root) {
    var wrapper = root.querySelector('quantity-wrapper');
    if (!wrapper || !wrapper.parentNode) return null;

    // Keep the "Adet"/"Quantity" label attached to its input by anchoring above
    // the label instead of between the label and the wrapper.
    var previous = wrapper.previousElementSibling;
    if (previous && previous.tagName === 'LABEL' && previous.getAttribute('for') === 'quantity') {
      return previous;
    }

    return wrapper;
  }

  // Places the customizer as a direct sibling right above the quantity selector,
  // giving the order: customizer -> quantity -> add to cart.
  function moveCmOptionsBeforeQuantity(root, anchor) {
    var moved = false;

    getCmOptions(root).forEach(function (cmOptions) {
      if (cmOptions === anchor || cmOptions.contains(anchor)) return;
      // Already sitting directly before the anchor — nothing to do.
      if (cmOptions.parentNode === anchor.parentNode && cmOptions.nextElementSibling === anchor) return;

      connectOptionsToForm(cmOptions, anchor);
      anchor.parentNode.insertBefore(cmOptions, anchor);
      moved = true;
    });

    return moved;
  }

  // Nearest ancestor shared by two nodes.
  function getCommonAncestor(a, b) {
    var seen = [];
    for (var n = a; n; n = n.parentNode) seen.push(n);
    for (var m = b; m; m = m.parentNode) {
      if (seen.indexOf(m) !== -1) return m;
    }
    return null;
  }

  // Given a flow container, return the direct child of it that contains `node`.
  function getFlowChild(container, node) {
    while (node && node.parentNode !== container) node = node.parentNode;
    return node;
  }

  // Fallback placement for products that have no Swatch King block.
  // Moves the customizer (#cm-options) out of the buy-buttons form and inserts
  // it right before the bundle block, producing the order the customer asked for:
  // model selection -> case colour/text customizer -> bundle -> add to cart.
  function moveCmOptionsBeforeBundle() {
    var root = getMainProductRoot();
    var bundle = root.querySelector(BUNDLE_SELECTOR);
    if (!bundle) return false;

    var bundleBlock = bundle.closest('[id^="shopify-block-"], .shopify-block, .shopify-app-block') || bundle;
    var moved = false;

    getCmOptions(root).forEach(function (cmOptions) {
      if (cmOptions === bundleBlock || cmOptions.contains(bundleBlock) || bundleBlock.contains(cmOptions)) return;

      // Insert the customizer at the same flow level as the bundle, right before
      // it. The flow container is whatever the bundle and the customizer share as
      // a common ancestor (the product form column that lays out the blocks).
      var flow = getCommonAncestor(cmOptions, bundleBlock);
      if (!flow) return;

      var anchor = getFlowChild(flow, bundleBlock);
      if (!anchor || anchor === cmOptions) return;
      // Already sitting directly before the bundle — nothing to do.
      if (cmOptions.parentNode === flow && cmOptions.nextElementSibling === anchor) return;

      connectOptionsToForm(cmOptions, bundleBlock);
      flow.insertBefore(cmOptions, anchor);
      moved = true;
    });

    return moved;
  }

  function moveMainProductCmOptions() {
    var root = getMainProductRoot();
    var quantityAnchor = getQuantityAnchor(root);

    // When the quantity selector is present it wins outright — returning here
    // stops the later passes (which run on an interval / MutationObserver) from
    // dragging the customizer back to the Swatch King or bundle position.
    if (quantityAnchor) {
      return moveCmOptionsBeforeQuantity(root, quantityAnchor);
    }
    
    var moved = false;
    var swatchKings = document.querySelectorAll(MAIN_SWATCH_SELECTOR);

    if (swatchKings.length) {
      swatchKings.forEach(function (swatchKing) {
        if (moveCmOptionsForSwatch(swatchKing)) moved = true;
      });
    } else if (moveCmOptionsBeforeBundle()) {
      // No Swatch King on this product: anchor the customizer to the bundle block.
      moved = true;
    }

    return moved;
  }

  function scheduleMove() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(moveMainProductCmOptions, 50);
  }

  function startRetry() {
    clearInterval(retryTimer);
    retryCount = 0;

    retryTimer = setInterval(function () {
      retryCount += 1;
      moveMainProductCmOptions();

      if (retryCount >= MAX_RETRIES) {
        clearInterval(retryTimer);
      }
    }, 500);
  }

  function init() {
    moveMainProductCmOptions();
    startRetry();

    if (!document.body || document.body._cmOptionsMoveObserver) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          scheduleMove();
          return;
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    document.body._cmOptionsMoveObserver = observer;
    document.addEventListener('shopify:section:load', function () {
      scheduleMove();
      startRetry();
    });
    window.addEventListener('load', scheduleMove);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  'use strict';

  var STYLE_ID = 'sumthincs-swatch-king-case-title-fix';
  var STYLE_CSS = [
    '.template-product variant-swatch-king .sumthincs-case-type-swatch .swatch-img-text-adjacent,',
    '.template-product variant-swatch-king [data-sumthincs-option="case-type"] .swatch-img-text-adjacent,',
    '.template-product variant-swatch-king [option-name*="Kılıf"] .swatch-img-text-adjacent,',
    '.template-product variant-swatch-king [option-name*="Case"] .swatch-img-text-adjacent {',
    '  display: flex !important;',
    '  justify-content: center !important;',
    '  align-items: center !important;',
    '  width: 100% !important;',
    '  max-width: 100% !important;',
    '  padding-left: 0 !important;',
    '  padding-right: 0 !important;',
    '  text-align: center !important;',
    '  white-space: normal !important;',
    '  overflow: visible !important;',
    '  text-overflow: clip !important;',
    '}',
    '.template-product variant-swatch-king .sumthincs-case-type-swatch .swatch-img-text-adjacent p,',
    '.template-product variant-swatch-king [data-sumthincs-option="case-type"] .swatch-img-text-adjacent p,',
    '.template-product variant-swatch-king [option-name*="Kılıf"] .swatch-img-text-adjacent p,',
    '.template-product variant-swatch-king [option-name*="Case"] .swatch-img-text-adjacent p {',
    '  display: block !important;',
    '  width: 100% !important;',
    '  max-width: 100% !important;',
    '  margin: 0 !important;',
    '  padding: 0 !important;',
    '  text-align: center !important;',
    '  white-space: normal !important;',
    '  overflow: visible !important;',
    '  text-overflow: clip !important;',
    '  line-height: 1.18 !important;',
    '  overflow-wrap: break-word !important;',
    '}'
  ].join('\n');

  function injectCaseTitleFix() {
    if (!document.head) return;

    var style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }

    if (style.textContent !== STYLE_CSS) {
      style.textContent = STYLE_CSS;
    }
  }

  function setImportantStyle(el, styles) {
    Object.keys(styles).forEach(function (property) {
      el.style.setProperty(property, styles[property], 'important');
    });
  }

  var CASE_TYPE_TITLE_FIXED_ATTR = 'data-sumthincs-case-title-fixed';
  var CASE_TYPE_DRAG_ATTR = 'data-sumthincs-case-type-native-drag';
  var CASE_TYPE_CLASS = 'sumthincs-case-type-swatch';
  var MODEL_CLASS = 'sumthincs-model-swatch';
  var MODEL_SELECTOR_ATTR = 'data-sumthincs-model-selector-fixed';
  var MODEL_NATIVE_HIDDEN_ATTR = 'data-sumthincs-model-native-hidden';
  var OPTION_ATTR = 'data-sumthincs-option';
  var caseTypeFixTimer = null;

  function normalizeOptionText(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/[\u0131\u0130]/g, 'i')
      .replace(/[\u015f\u015e]/g, 's')
      .replace(/[\u011f\u011e]/g, 'g')
      .replace(/[\u00fc\u00dc]/g, 'u')
      .replace(/[\u00f6\u00d6]/g, 'o')
      .replace(/[\u00e7\u00c7]/g, 'c')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ı/g, 'i')
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function classifyOptionText(value) {
    var normalized = normalizeOptionText(value);
    if (!normalized) return null;

    if ((normalized.indexOf('kilif') !== -1 && normalized.indexOf('tur') !== -1) || normalized.indexOf('case type') !== -1) {
      return 'case-type';
    }

    if (normalized === 'model' || normalized.indexOf('model ') === 0 || normalized.indexOf('model sec') !== -1) {
      return 'model';
    }

    return null;
  }

  function getCandidateOptionText(candidate) {
    var attrNames = ['option-name', 'data-option-name', 'data-option', 'aria-label'];
    for (var i = 0; i < attrNames.length; i++) {
      var attrValue = candidate.getAttribute && candidate.getAttribute(attrNames[i]);
      if (attrValue && classifyOptionText(attrValue)) return attrValue;
    }

    var labels = candidate.querySelectorAll
      ? candidate.querySelectorAll('.swatch-label, .swatch-option-name, legend, label')
      : [];

    for (var j = 0; j < labels.length; j++) {
      var text = labels[j].textContent;
      if (text && classifyOptionText(text)) return text;
    }

    return '';
  }

  function getSwatchOptionRoot(el) {
    return (
      el.closest('[option-name]') ||
      el.closest('[data-option-name]') ||
      el.closest('.swatch-single') ||
      el.closest('.swatch-group') ||
      el.closest('fieldset') ||
      el
    );
  }

  function markSwatchOption(candidate) {
    if (!candidate || candidate.nodeType !== 1) return;

    var optionType = classifyOptionText(getCandidateOptionText(candidate));
    if (!optionType) return;

    var root = getSwatchOptionRoot(candidate);
    root.setAttribute(OPTION_ATTR, optionType);

    if (optionType === 'case-type') {
      root.classList.add(CASE_TYPE_CLASS);
    } else if (optionType === 'model') {
      root.classList.add(MODEL_CLASS);
    }
  }

  function markSwatchOptions() {
    document
      .querySelectorAll(
        '.template-product variant-swatch-king [option-name], ' +
          '.template-product variant-swatch-king [data-option-name], ' +
          '.template-product variant-swatch-king .swatch-label, ' +
          '.template-product variant-swatch-king .swatch-option-name, ' +
          '.template-product variant-swatch-king legend'
      )
      .forEach(markSwatchOption);
  }

  function getModelSwatchRoots() {
    return document.querySelectorAll(
      '.template-product variant-swatch-king [data-sumthincs-option="model"], ' +
        '.template-product variant-swatch-king .sumthincs-model-swatch, ' +
        '.template-product variant-swatch-king [option-name="Model"], ' +
        '.template-product variant-swatch-king [option-name*="Model"]'
    );
  }

  function hideModelNativeUi(root) {
    root.querySelectorAll('.sumthincs-product-selector__label').forEach(function (node) {
      node.remove();
    });
    root.classList.remove('sumthincs-product-selector', 'sumthincs-product-selector--open');

    root.querySelectorAll('fieldset, .swatch-single, .swatch-drop-down-wrapper, .swatch-view-select').forEach(function (node) {
      if (node.closest('.sumthincs-model-brand-dropdown')) return;
      node.setAttribute(MODEL_NATIVE_HIDDEN_ATTR, 'true');
    });
  }

  function collectModelOptionData(root) {
    var options = [];
    var seen = {};

    function getModelOptionUrl(el) {
      if (!el) return '';

      var url =
        el.getAttribute('data-url') ||
        el.getAttribute('data-product-url') ||
        el.getAttribute('swatch-url') ||
        el.getAttribute('href') ||
        '';
      var value = el.getAttribute('value') || '';

      if (!url && /^https?:\/\//.test(value)) url = value;
      if (!url && value.indexOf('/products/') === 0) url = value;

      return url;
    }

    function pushOption(label, data) {
      var key = String(label || '').trim();
      if (!key || seen[key]) return;
      seen[key] = true;
      options.push(
        Object.assign(
          {
            label: key,
            value: key
          },
          data
        )
      );
    }

    root.querySelectorAll('select option').forEach(function (optionEl) {
      var label = optionEl.textContent.trim();
      if (!label) return;
      pushOption(label, {
        value: optionEl.value || label,
        url: getModelOptionUrl(optionEl),
        nativeOption: optionEl,
        selected: optionEl.selected
      });
    });

    root.querySelectorAll('.swatch-drop-down-list .swatch-view-item, .swatch-drop-down-list > div, .swatch-drop-down-list li').forEach(function (item) {
      var label = item.getAttribute('orig-value') || item.getAttribute('aria-label') || item.textContent.trim();
      if (!label) return;
      pushOption(label, {
        value: item.getAttribute('data-value') || label,
        url: getModelOptionUrl(item),
        listItem: item
      });
    });

    root.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var labelNode = input.id ? root.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
      var label = labelNode ? labelNode.textContent.trim() : input.value;
      if (!label) return;
      pushOption(label, {
        value: input.value || label,
        url: getModelOptionUrl(input) || (labelNode ? getModelOptionUrl(labelNode) : ''),
        input: input,
        selected: input.checked
      });
    });

    return options;
  }

  function getCurrentModelLabel(root) {
    var selectedText = root.querySelector('.swatch-drop-down > span, .swatch-drop-down .swatch-title, .swatch-selected-value');
    if (selectedText && selectedText.textContent.trim()) {
      return selectedText.textContent.trim();
    }

    var checked = root.querySelector('input[type="radio"]:checked');
    if (checked) {
      var checkedLabel = checked.id ? root.querySelector('label[for="' + CSS.escape(checked.id) + '"]') : null;
      if (checkedLabel && checkedLabel.textContent.trim()) return checkedLabel.textContent.trim();
      if (checked.value) return checked.value;
    }

    var nativeSelect = root.querySelector('select');
    if (nativeSelect && nativeSelect.selectedIndex >= 0) {
      return nativeSelect.options[nativeSelect.selectedIndex].textContent.trim();
    }

    return '';
  }

  function applyModelSelection(root, optionData) {
    if (!optionData) return;

    if (optionData.url) {
      window.location.href = optionData.url;
      return;
    }

    if (optionData.nativeOption) {
      var nativeSelect = optionData.nativeOption.closest('select');
      if (nativeSelect) {
        nativeSelect.value = optionData.nativeOption.value;
        nativeSelect.dispatchEvent(new Event('input', { bubbles: true }));
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }

    if (optionData.input) {
      optionData.input.checked = true;
      optionData.input.dispatchEvent(new Event('input', { bubbles: true }));
      optionData.input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    if (optionData.listItem) {
      optionData.listItem.click();
    }
  }

  function buildBrandStyleModelDropdown(root) {
    if (root.querySelector('.sumthincs-model-brand-dropdown')) return false;

    var optionData = collectModelOptionData(root);
    if (!optionData.length) return false;

    var wrapper = document.createElement('div');
    wrapper.className = 'brand-dropdown sumthincs-model-brand-dropdown not-in-quickbuy';

    var selectId = 'modelSelect-' + Math.random().toString(36).slice(2);
    var label = document.createElement('label');
    label.setAttribute('for', selectId);
    label.textContent = getModelLabelText(root) + '\u00a0';

    var select = document.createElement('select');
    select.id = selectId;
    select.className = 'js-model-select';
    select.name = 'model';

    optionData.forEach(function (option, index) {
      var optionEl = document.createElement('option');
      optionEl.value = option.value || String(index);
      optionEl.textContent = option.label;
      if (option.url) optionEl.setAttribute('data-url', option.url);
      if (option.selected) optionEl.selected = true;
      select.appendChild(optionEl);
    });

    var currentLabel = getCurrentModelLabel(root);
    if (currentLabel) {
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].textContent.trim() === currentLabel) {
          select.selectedIndex = i;
          break;
        }
      }
    }

    if (window.sumthincsGetProductHandle) {
      var currentHandle = window.sumthincsGetProductHandle(location.href);
      for (var j = 0; j < select.options.length; j++) {
        var optionHandle = window.sumthincsGetProductHandle(select.options[j].getAttribute('data-url'));
        if (optionHandle && optionHandle === currentHandle) {
          select.selectedIndex = j;
          break;
        }
      }
    }

    wrapper.appendChild(label);
    wrapper.appendChild(select);
    root.insertBefore(wrapper, root.firstChild);

    select.addEventListener('change', function () {
      var selectedOption = select.options[select.selectedIndex];
      var url = selectedOption.getAttribute('data-url');
      if (url) {
        window.location.href = url;
        return;
      }
      applyModelSelection(root, optionData[select.selectedIndex]);
    });

    hideModelNativeUi(root);

    if (window.sumthincsEnhanceBrandDropdown) {
      window.sumthincsEnhanceBrandDropdown(wrapper, select);
    }

    return true;
  }

  function convertVariantPickerModelToBrandDropdown() {
    if (document.querySelector('.template-product variant-swatch-king [option-name="Model"], .template-product variant-swatch-king [data-sumthincs-option="model"]')) {
      return;
    }

    document.querySelectorAll('.template-product variant-picker .option-selector[data-option="Model"]').forEach(function (optionSelector) {
      if (optionSelector.querySelector('.sumthincs-model-brand-dropdown')) return;

      var labelNode = optionSelector.querySelector('.label');
      var listbox = optionSelector.querySelector('.custom-select__listbox');
      if (!listbox) return;

      var optionNodes = listbox.querySelectorAll('[role="option"], .custom-select__option');
      if (!optionNodes.length) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'brand-dropdown sumthincs-model-brand-dropdown not-in-quickbuy';

      var selectId = 'modelSelect-' + Math.random().toString(36).slice(2);
      var label = document.createElement('label');
      label.setAttribute('for', selectId);
      label.textContent = (labelNode ? labelNode.textContent.trim() : 'Model') + '\u00a0';

      var select = document.createElement('select');
      select.id = selectId;
      select.className = 'js-model-select';
      select.name = 'model';

      var optionData = [];
      optionNodes.forEach(function (node, index) {
        var text = node.textContent.trim();
        if (!text) return;
        var optionEl = document.createElement('option');
        optionEl.value = node.getAttribute('data-value') || String(index);
        optionEl.textContent = text;
        if (node.getAttribute('aria-selected') === 'true') optionEl.selected = true;
        select.appendChild(optionEl);
        optionData.push({ label: text, listItem: node });
      });

      if (!optionData.length) return;

      wrapper.appendChild(label);
      wrapper.appendChild(select);
      optionSelector.insertBefore(wrapper, optionSelector.firstChild);

      select.addEventListener('change', function () {
        applyModelSelection(optionSelector, optionData[select.selectedIndex]);
      });

      optionSelector.querySelectorAll('custom-select, .label').forEach(function (node) {
        node.setAttribute(MODEL_NATIVE_HIDDEN_ATTR, 'true');
      });

      if (window.sumthincsEnhanceBrandDropdown) {
        window.sumthincsEnhanceBrandDropdown(wrapper, select);
      }
    });
  }

  function hideVariantPickerModelDuplicate() {
    if (!getModelSwatchRoots().length) return;

    document.querySelectorAll('.template-product variant-picker .option-selector[data-option="Model"]').forEach(function (el) {
      el.setAttribute('hidden', 'hidden');
      el.setAttribute(MODEL_NATIVE_HIDDEN_ATTR, 'true');
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function getModelLabelText(root) {
    var attrNames = ['option-name', 'data-option-name'];
    for (var i = 0; i < attrNames.length; i++) {
      var attrValue = root.getAttribute(attrNames[i]);
      if (attrValue && classifyOptionText(attrValue) === 'model') {
        return attrValue.trim();
      }
    }

    var optionName = root.querySelector('.swatch-option-name');
    if (optionName && optionName.textContent) {
      return optionName.textContent.split(':')[0].trim();
    }

    var legend = root.querySelector('legend');
    if (legend && legend.textContent) {
      return legend.textContent.trim();
    }

    return 'Model';
  }

  function applyModelSelectorFix() {
    hideVariantPickerModelDuplicate();

    getModelSwatchRoots().forEach(function (root) {
      if (root.querySelector('.sumthincs-model-brand-dropdown')) return;
      if (buildBrandStyleModelDropdown(root)) {
        root.setAttribute(MODEL_SELECTOR_ATTR, 'true');
      }
    });

    convertVariantPickerModelToBrandDropdown();
    applyEasifyModelBrandStyle();

    if (window.sumthincsInitBrandDropdowns) {
      window.sumthincsInitBrandDropdowns();
    }
  }

  var EASIFY_MODEL_ATTR = 'data-sumthincs-easify-model-fixed';
  var EASIFY_MODEL_READY_CLASS = 'sumthincs-easify-model-ready';
  var easifyModelControllerStarted = false;
  var easifyModelFallbackTimer = null;
  var easifyModelGuessedLabel = '';

  function cleanupEasifyModelSkeleton() {
    document.querySelectorAll('.sumthincs-easify-model-skeleton, [data-sumthincs-easify-model-skeleton="true"]').forEach(function (node) {
      node.remove();
    });
  }

  function isEasifyModelLabel(label) {
    if (!label || !label.textContent) return false;
    return normalizeOptionText(label.textContent) === 'model';
  }

  function isEasifyPlaceholderText(text) {
    var normalized = normalizeOptionText(text || '');
    return !normalized || normalized === 'seciniz' || normalized === 'select' || normalized === 'choose' || normalized === 'sec';
  }

  function getTpoModelOptionLabels() {
    var cfg = window.TPOConfigs;
    var labels = [];
    var seen = {};

    if (!cfg || !Array.isArray(cfg.option_sets_searchable)) return labels;

    cfg.option_sets_searchable.forEach(function (set) {
      if (!set || !set.data || !Array.isArray(set.data.options)) return;

      set.data.options.forEach(function (option) {
        if (normalizeOptionText(option.title) !== 'model' && normalizeOptionText(option.option_identifier) !== 'model') {
          return;
        }

        (option.option_types || []).forEach(function (type) {
          var label = (type.label || '').trim();
          if (!label || seen[label]) return;
          seen[label] = true;
          labels.push(label);
        });
      });
    });

    return labels;
  }

  function guessModelLabelFromPage(optionLabels) {
    if (!optionLabels.length) return '';

    var haystacks = [];
    var cfg = window.TPOConfigs;

    if (cfg && cfg.current_product && cfg.current_product.handle) {
      haystacks.push(String(cfg.current_product.handle).toLowerCase());
    }
    if (cfg && cfg.current_product && cfg.current_product.title) {
      haystacks.push(String(cfg.current_product.title).toLowerCase());
    }

    haystacks.push((document.title || '').toLowerCase());
    haystacks.push((location.pathname || '').toLowerCase());

    document
      .querySelectorAll('.breadcrumb a, .breadcrumbs a, nav[aria-label*="breadcrumb"] a, .breadcrumbs__link')
      .forEach(function (link) {
        var text = (link.textContent || '').trim().toLowerCase();
        if (text) haystacks.push(text);
      });

    var sortedLabels = optionLabels.slice().sort(function (a, b) {
      return b.length - a.length;
    });

    for (var i = 0; i < sortedLabels.length; i++) {
      var label = sortedLabels[i];
      var slug = label
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
      var compact = label.toLowerCase().replace(/[^a-z0-9]/g, '');

      for (var j = 0; j < haystacks.length; j++) {
        var hay = haystacks[j];
        var hayCompact = hay.replace(/[^a-z0-9]/g, '');
        if ((slug && hay.indexOf(slug) !== -1) || (compact && hayCompact.indexOf(compact) !== -1)) {
          return label;
        }
      }
    }

    return '';
  }

  function getEasifyModelDisplayText(field) {
    if (!field) return '';

    var selected = field.querySelector('.po-select-selectedValue');
    if (selected && selected.textContent.trim()) {
      return selected.textContent.trim();
    }

    var placeholder = field.querySelector('.po-select-placeholder');
    if (!placeholder) {
      var button = field.querySelector('.po-select-button');
      return button ? button.textContent.trim() : '';
    }

    var clone = placeholder.cloneNode(true);
    clone.querySelectorAll('.po-select-selectedPrice').forEach(function (node) {
      node.remove();
    });

    return clone.textContent.trim();
  }

  function setEasifyPlaceholderText(field, label) {
    var placeholder = field.querySelector('.po-select-placeholder');
    if (!placeholder || !label) return;

    var priceEl = placeholder.querySelector('.po-select-selectedPrice');
    placeholder.textContent = '';
    placeholder.appendChild(document.createTextNode(label + ' '));
    if (priceEl) placeholder.appendChild(priceEl);
    field.setAttribute('data-sumthincs-model-prefill', label);
  }

  function markEasifyModelReady(field) {
    if (!field || field.classList.contains(EASIFY_MODEL_READY_CLASS)) return;
    field.classList.add(EASIFY_MODEL_READY_CLASS);
  }

  function tryMarkEasifyModelReady(field) {
    if (!field || field.classList.contains(EASIFY_MODEL_READY_CLASS)) return;

    var displayText = getEasifyModelDisplayText(field);
    if (!isEasifyPlaceholderText(displayText)) {
      markEasifyModelReady(field);
      return;
    }

    var prefill = field.getAttribute('data-sumthincs-model-prefill');
    if (prefill && displayText.indexOf(prefill) !== -1) {
      markEasifyModelReady(field);
    }
  }

  function scheduleEasifyModelReadyFallback(field) {
    if (!field || field.classList.contains(EASIFY_MODEL_READY_CLASS)) return;
    if (field.getAttribute('data-sumthincs-easify-model-ready-timer') === 'true') return;
    field.setAttribute('data-sumthincs-easify-model-ready-timer', 'true');
    window.setTimeout(function () {
      markEasifyModelReady(field);
    }, 800);
  }

  function watchEasifyModelField(field) {
    if (!field || field.getAttribute('data-sumthincs-easify-model-watched') === 'true') return;
    field.setAttribute('data-sumthincs-easify-model-watched', 'true');

    var button = field.querySelector('.po-select-button');
    if (!button) return;

    var observer = new MutationObserver(function () {
      tryMarkEasifyModelReady(field);
    });

    observer.observe(button, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-expanded']
    });
  }

  function syncEasifyModelOpenState(field) {
    var button = field.querySelector('.po-select-button');
    if (!button) return;
    field.classList.toggle('brand-dropdown--open', button.getAttribute('aria-expanded') === 'true');
  }

  function bindEasifyModelField(field) {
    var selectRoot = field.querySelector('.po-select-root');
    if (selectRoot && !selectRoot.querySelector('.brand-dropdown__arrow')) {
      var arrow = document.createElement('span');
      arrow.className = 'brand-dropdown__arrow';
      arrow.innerHTML =
        '<svg class="brand-dropdown__icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg>';
      selectRoot.appendChild(arrow);
    }

    var button = field.querySelector('.po-select-button');
    if (button && button.getAttribute('data-sumthincs-easify-model-bound') !== 'true') {
      button.setAttribute('data-sumthincs-easify-model-bound', 'true');
      button.addEventListener('click', function () {
        window.setTimeout(function () {
          syncEasifyModelOpenState(field);
        }, 0);
      });
      button.addEventListener('blur', function () {
        window.setTimeout(function () {
          syncEasifyModelOpenState(field);
        }, 120);
      });
    }

    syncEasifyModelOpenState(field);
  }

  function applyEasifyModelBrandStyle() {
    cleanupEasifyModelSkeleton();

    if (!easifyModelGuessedLabel) {
      easifyModelGuessedLabel = guessModelLabelFromPage(getTpoModelOptionLabels());
    }

    document.querySelectorAll('.template-product .easify .po-field-root').forEach(function (field) {
      var label = field.querySelector('.po-label-label');
      if (!isEasifyModelLabel(label)) return;

      if (field.getAttribute(EASIFY_MODEL_ATTR) !== 'true') {
        field.setAttribute(EASIFY_MODEL_ATTR, 'true');
        field.classList.add('brand-dropdown', 'sumthincs-easify-model-brand', 'not-in-quickbuy');

        var required = field.querySelector('.po-label-required');
        if (required) required.setAttribute(MODEL_NATIVE_HIDDEN_ATTR, 'true');

        if (label && label.textContent.indexOf('\u00a0') === -1) {
          label.appendChild(document.createTextNode('\u00a0'));
        }

        var easifyRoot = field.closest('.easify');
        if (easifyRoot) {
          easifyRoot.style.setProperty('width', '100%', 'important');
          easifyRoot.style.setProperty('max-width', '100%', 'important');
        }

        var themedRoot = field.closest('[data-tpo-theme]');
        if (themedRoot) {
          themedRoot.style.setProperty('width', '100%', 'important');
          themedRoot.style.setProperty('max-width', '100%', 'important');
        }

        var optionRoot = field.closest('.po-option-root');
        if (optionRoot) optionRoot.style.setProperty('width', '100%', 'important');
      }

      // NOTE: Do NOT rewrite Easify's placeholder text here. Easify is React-based;
      // mutating `.po-select-placeholder` text nodes corrupts its virtual DOM and
      // prevents model selections from registering (the button stayed stuck on a
      // fake pre-filled model). We let Easify own its own placeholder/selected text.

      bindEasifyModelField(field);
      watchEasifyModelField(field);
      tryMarkEasifyModelReady(field);
      scheduleEasifyModelReadyFallback(field);
    });
  }

  function forceEasifyModelReadyFallback() {
    document.querySelectorAll('.template-product .easify .sumthincs-easify-model-brand').forEach(function (field) {
      markEasifyModelReady(field);
    });
  }

  function initEasifyModelController() {
    cleanupEasifyModelSkeleton();
    applyEasifyModelBrandStyle();

    if (easifyModelControllerStarted) return;
    easifyModelControllerStarted = true;

    if (easifyModelFallbackTimer) {
      window.clearTimeout(easifyModelFallbackTimer);
    }
    easifyModelFallbackTimer = window.setTimeout(forceEasifyModelReadyFallback, 2800);

    var targets = [
      document.querySelector('#product-options'),
      document.querySelector('.easify'),
      document.querySelector('.template-product .product-form, .template-product product-form')
    ].filter(Boolean);

    if (!targets.length) targets.push(document.body);

    targets.forEach(function (target) {
      new MutationObserver(function () {
        applyEasifyModelBrandStyle();
      }).observe(target, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }

  function bindCaseTypeNativeDrag(slider) {
    if (isCaseTypeLinkGrid(slider)) {
      bindCaseTypeLinkGrid(slider);
      return;
    }

    if (slider.getAttribute(CASE_TYPE_DRAG_ATTR) === 'true') return;
    slider.setAttribute(CASE_TYPE_DRAG_ATTR, 'true');

    var DRAG_THRESHOLD = 5;
    var SUPPRESS_CLICK_MS = 450;

    var drag = {
      pointerId: null,
      startX: 0,
      startY: 0,
      startScrollLeft: 0,
      moved: false,
      isTouch: false,
      suppressClick: false,
      suppressTimer: null,
      animationFrame: null,
      tapTarget: null
    };

    function hasOverflow() {
      return slider.scrollWidth > slider.clientWidth + 2;
    }

    function isDescendantTarget(evt) {
      return evt.target !== slider && slider.contains(evt.target);
    }

    function cancelScrollAnimation() {
      if (!drag.animationFrame) return;
      window.cancelAnimationFrame(drag.animationFrame);
      drag.animationFrame = null;
    }

    function getNearestSnapLeft() {
      var items = Array.prototype.slice.call(slider.querySelectorAll('.swatch-view-item, .cts-card'));
      if (!items.length) return slider.scrollLeft;

      var sliderRect = slider.getBoundingClientRect();
      var currentLeft = slider.scrollLeft;
      var maxLeft = slider.scrollWidth - slider.clientWidth;
      var nearestLeft = currentLeft;
      var nearestDistance = Infinity;

      items.forEach(function (item) {
        var itemLeft = currentLeft + item.getBoundingClientRect().left - sliderRect.left;
        var clampedLeft = Math.max(0, Math.min(itemLeft, maxLeft));
        var distance = Math.abs(clampedLeft - currentLeft);

        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestLeft = clampedLeft;
        }
      });

      return nearestLeft;
    }

    function smoothSnapToNearestItem() {
      if (!hasOverflow()) return;

      var targetLeft = getNearestSnapLeft();
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      cancelScrollAnimation();

      if (prefersReducedMotion) {
        slider.scrollLeft = targetLeft;
        return;
      }

      var startLeft = slider.scrollLeft;
      var distance = targetLeft - startLeft;
      var duration = Math.min(360, Math.max(180, Math.abs(distance) * 2.2));
      var startTime = window.performance.now();

      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }

      function animate(now) {
        var progress = Math.min(1, (now - startTime) / duration);
        slider.scrollLeft = startLeft + distance * easeOutCubic(progress);

        if (progress < 1) {
          drag.animationFrame = window.requestAnimationFrame(animate);
        } else {
          drag.animationFrame = null;
        }
      }

      drag.animationFrame = window.requestAnimationFrame(animate);
    }

    function markDragMoved() {
      if (drag.moved) return;
      drag.moved = true;
      slider.classList.add('is-native-dragging');
      if (drag.isTouch) {
        addDocumentCaptureBlockers();
      }
    }

    function releasePointerCaptureSafe() {
      if (drag.isTouch || drag.pointerId === null || !slider.releasePointerCapture) return;

      try {
        slider.releasePointerCapture(drag.pointerId);
      } catch (err) {
        // Pointer capture may already be released by the browser.
      }
    }

    function scheduleClickSuppression() {
      drag.suppressClick = true;
      slider.classList.add('is-native-dragging');

      if (drag.suppressTimer) {
        window.clearTimeout(drag.suppressTimer);
      }

      drag.suppressTimer = window.setTimeout(function () {
        drag.suppressTimer = null;
        drag.suppressClick = false;
        drag.moved = false;
        slider.classList.remove('is-native-dragging');
        removeDocumentCaptureBlockers();
      }, SUPPRESS_CLICK_MS);
    }

    function stopEvent(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();
    }

    var documentCaptureEvents = ['mousedown', 'mouseup', 'click', 'touchstart', 'touchend', 'pointerup', 'change'];

    function onDocumentCapture(evt) {
      if (!slider.contains(evt.target)) return;
      if (!shouldBlockDescendantEvent(evt)) return;
      stopEvent(evt);
    }

    function addDocumentCaptureBlockers() {
      documentCaptureEvents.forEach(function (eventName) {
        document.addEventListener(eventName, onDocumentCapture, true);
      });
    }

    function removeDocumentCaptureBlockers() {
      documentCaptureEvents.forEach(function (eventName) {
        document.removeEventListener(eventName, onDocumentCapture, true);
      });
    }

    function shouldBlockDescendantEvent(evt) {
      if (!isDescendantTarget(evt)) return false;

      if (drag.suppressClick || drag.moved) return true;

      if (drag.pointerId === null) return false;

      // Touch taps should reach links/labels natively when the gesture did not scroll.
      if (drag.isTouch && !drag.moved) return false;

      if (!drag.isTouch) return true;

      return evt.type === 'touchend' || evt.type === 'click' || evt.type === 'pointerup';
    }

    function blockDescendantInteraction(evt) {
      if (evt.pointerType === 'touch' || (evt.type && evt.type.indexOf('touch') === 0)) return;
      if (!shouldBlockDescendantEvent(evt)) return;
      stopEvent(evt);
    }

    function resolveTapTarget(target) {
      if (!target) return null;
      return (
        target.closest('.cts-card, .swatch-view-item, label.swatch-image, .swatch-image, label') || target
      );
    }

    function activateTapTarget(target) {
      if (!target) return;

      var link = target.closest('a[href]');
      if (link && link.href) {
        window.location.assign(link.href);
        return;
      }

      if (target.matches('a.cts-card')) {
        window.location.assign(target.href);
        return;
      }

      var input = target.querySelector('input[type="radio"], input[type="checkbox"]');
      if (!input && target.matches('input[type="radio"], input[type="checkbox"]')) {
        input = target;
      }

      if (input) {
        if (!input.checked) {
          input.checked = true;
        }
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      var label = target.closest('label') || target.querySelector('label');
      if (label) {
        label.click();
        return;
      }

      target.click();
    }

    function finishDrag() {
      var wasMoved = drag.moved;
      var wasTouch = drag.isTouch;
      var tapTarget = drag.tapTarget;

      releasePointerCaptureSafe();
      drag.pointerId = null;
      drag.isTouch = false;
      drag.tapTarget = null;

      if (wasMoved) {
        if (!wasTouch) {
          smoothSnapToNearestItem();
        }
        scheduleClickSuppression();
        return;
      }

      removeDocumentCaptureBlockers();
      slider.classList.remove('is-native-dragging');

      if (!wasTouch) {
        window.requestAnimationFrame(function () {
          activateTapTarget(tapTarget);
        });
      } else if (tapTarget) {
        window.requestAnimationFrame(function () {
          activateTapTarget(tapTarget);
        });
      }
    }

    slider.addEventListener(
      'pointerdown',
      function (evt) {
        if (evt.button !== 0 || !hasOverflow()) return;

        cancelScrollAnimation();
        drag.pointerId = evt.pointerId;
        drag.startX = evt.clientX;
        drag.startY = evt.clientY;
        drag.startScrollLeft = slider.scrollLeft;
        drag.moved = false;
        drag.isTouch = evt.pointerType === 'touch';
        drag.tapTarget = resolveTapTarget(evt.target);

        if (!drag.isTouch) {
          addDocumentCaptureBlockers();
          if (slider.setPointerCapture) {
            slider.setPointerCapture(evt.pointerId);
          }
        }
      },
      true
    );

    slider.addEventListener(
      'pointermove',
      function (evt) {
        if (drag.pointerId !== evt.pointerId) return;

        var deltaX = evt.clientX - drag.startX;
        var deltaY = evt.clientY - drag.startY;

        if (!drag.moved) {
          if (Math.abs(deltaX) < DRAG_THRESHOLD && Math.abs(deltaY) < DRAG_THRESHOLD) return;
          if (drag.isTouch && Math.abs(deltaX) <= Math.abs(deltaY)) return;
          markDragMoved();
        }

        if (drag.isTouch) return;

        evt.preventDefault();
        slider.scrollLeft = drag.startScrollLeft - deltaX;
      },
      true
    );

    slider.addEventListener(
      'pointerup',
      function (evt) {
        if (drag.pointerId !== evt.pointerId) return;
        finishDrag();
      },
      true
    );

    slider.addEventListener(
      'pointercancel',
      function (evt) {
        if (drag.pointerId !== evt.pointerId) return;

        releasePointerCaptureSafe();
        drag.pointerId = null;
        drag.isTouch = false;
        drag.tapTarget = null;
        removeDocumentCaptureBlockers();

        if (!drag.suppressClick) {
          slider.classList.remove('is-native-dragging');
        }
      },
      true
    );

    slider.addEventListener(
      'scroll',
      function () {
        if (drag.pointerId === null || !drag.isTouch) return;
        if (Math.abs(slider.scrollLeft - drag.startScrollLeft) < 10) return;
        markDragMoved();
      },
      { passive: true }
    );

    ['mousedown', 'mouseup', 'click', 'pointerdown', 'pointerup'].forEach(function (eventName) {
      slider.addEventListener(eventName, blockDescendantInteraction, true);
    });

    slider.addEventListener(
      'change',
      function (evt) {
        if (!drag.suppressClick && !drag.moved) return;
        stopEvent(evt);
      },
      true
    );
  }

  var CASE_TYPE_LINK_GRID_ATTR = 'data-sumthincs-cts-links-bound';

  function isCaseTypeLinkGrid(slider) {
    return !!(slider && (slider.classList.contains('cts-grid') || slider.closest('.case-type-selector')));
  }

  function resetCaseTypeLinkGrid(grid) {
    if (!grid || grid.getAttribute('data-sumthincs-cts-reset') === 'true') return grid;

    if (grid.getAttribute(CASE_TYPE_DRAG_ATTR) === 'true') {
      var clone = grid.cloneNode(true);
      clone.removeAttribute(CASE_TYPE_DRAG_ATTR);
      clone.classList.remove('is-native-dragging');
      clone.setAttribute('data-sumthincs-cts-reset', 'true');
      grid.parentNode.replaceChild(clone, grid);
      return clone;
    }

    grid.setAttribute('data-sumthincs-cts-reset', 'true');
    return grid;
  }

  function bindCaseTypeLinkGrid(grid) {
    grid = resetCaseTypeLinkGrid(grid);
    if (!grid || grid.getAttribute(CASE_TYPE_LINK_GRID_ATTR) === 'true') return;
    grid.setAttribute(CASE_TYPE_LINK_GRID_ATTR, 'true');

    var gesture = {
      startX: 0,
      startY: 0,
      startScrollLeft: 0,
      moved: false,
      card: null
    };

    grid.addEventListener(
      'touchstart',
      function (evt) {
        var touch = evt.changedTouches[0];
        if (!touch) return;
        gesture.startX = touch.clientX;
        gesture.startY = touch.clientY;
        gesture.startScrollLeft = grid.scrollLeft;
        gesture.moved = false;
        gesture.card = evt.target.closest('a.cts-card');
      },
      { passive: true }
    );

    grid.addEventListener(
      'touchmove',
      function (evt) {
        var touch = evt.changedTouches[0];
        if (!touch) return;
        if (Math.abs(touch.clientX - gesture.startX) > 8 || Math.abs(touch.clientY - gesture.startY) > 8) {
          gesture.moved = true;
        }
        if (Math.abs(grid.scrollLeft - gesture.startScrollLeft) > 6) {
          gesture.moved = true;
        }
      },
      { passive: true }
    );

    grid.addEventListener(
      'touchend',
      function (evt) {
        if (gesture.moved) {
          gesture.card = null;
          return;
        }

        var card = gesture.card || evt.target.closest('a.cts-card');
        gesture.card = null;
        if (!card || !card.href || card.classList.contains('is-active')) return;

        evt.preventDefault();
        window.location.assign(card.href);
      },
      { passive: false }
    );

    grid.addEventListener('click', function (evt) {
      var card = evt.target.closest('a.cts-card');
      if (!card || !card.href || card.classList.contains('is-active')) return;
      if (evt.defaultPrevented) {
        window.location.assign(card.href);
      }
    });
  }

  function initCaseTypeLinkGrids() {
    document.querySelectorAll('.template-product .case-type-selector .cts-grid').forEach(bindCaseTypeLinkGrid);
  }

  function initCaseTypeNativeDrag() {
    document
      .querySelectorAll(
        '.template-product variant-swatch-king .sumthincs-case-type-swatch .swatch-view-image, ' +
          '.template-product variant-swatch-king [data-sumthincs-option="case-type"] .swatch-view-image, ' +
          '.template-product variant-swatch-king [option-name*="Kılıf"] .swatch-view-image, ' +
          '.template-product variant-swatch-king [option-name*="Case"] .swatch-view-image'
      )
      .forEach(bindCaseTypeNativeDrag);
  }

  function applyCaseTitleFix() {
    markSwatchOptions();
    applyModelSelectorFix();
    initEasifyModelController();
    initCaseTypeLinkGrids();
    initCaseTypeNativeDrag();

    document
      .querySelectorAll(
        '.template-product variant-swatch-king .sumthincs-case-type-swatch .swatch-img-text-adjacent, ' +
          '.template-product variant-swatch-king [data-sumthincs-option="case-type"] .swatch-img-text-adjacent, ' +
          '.template-product variant-swatch-king [option-name*="Kılıf"] .swatch-img-text-adjacent, ' +
          '.template-product variant-swatch-king [option-name*="Case"] .swatch-img-text-adjacent'
      )
      .forEach(function (label) {
        if (label.getAttribute(CASE_TYPE_TITLE_FIXED_ATTR) === 'true') return;
        label.setAttribute(CASE_TYPE_TITLE_FIXED_ATTR, 'true');
        setImportantStyle(label, {
          display: 'flex',
          'justify-content': 'center',
          'align-items': 'center',
          width: '100%',
          'max-width': '100%',
          'text-align': 'center',
          'white-space': 'normal',
          overflow: 'visible',
          'text-overflow': 'clip'
        });
      });

    document
      .querySelectorAll(
        '.template-product variant-swatch-king .sumthincs-case-type-swatch .swatch-img-text-adjacent p, ' +
          '.template-product variant-swatch-king [data-sumthincs-option="case-type"] .swatch-img-text-adjacent p, ' +
          '.template-product variant-swatch-king [option-name*="Kılıf"] .swatch-img-text-adjacent p, ' +
          '.template-product variant-swatch-king [option-name*="Case"] .swatch-img-text-adjacent p'
      )
      .forEach(function (labelText) {
        if (labelText.getAttribute(CASE_TYPE_TITLE_FIXED_ATTR) === 'true') return;
        labelText.setAttribute(CASE_TYPE_TITLE_FIXED_ATTR, 'true');
        setImportantStyle(labelText, {
          display: 'block',
          width: '100%',
          'max-width': '100%',
          margin: '0',
          padding: '0',
          'text-align': 'center',
          'white-space': 'normal',
          overflow: 'visible',
          'text-overflow': 'clip',
          'line-height': '1.18',
          'overflow-wrap': 'break-word'
        });
      });
  }

  function nodeRelatesToCaseType(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches('variant-swatch-king, variant-picker, [option-name], [data-option-name], .swatch-label, .swatch-option-name, .case-type-selector, .cts-grid, .cts-card, .sumthincs-product-selector, .easify, .po-field-root, .po-select-root')) return true;
    if (node.querySelector && node.querySelector('variant-swatch-king, variant-picker, [option-name], [data-option-name], .swatch-label, .swatch-option-name, .case-type-selector, .cts-grid, .cts-card, .sumthincs-product-selector, .easify, .po-field-root, .po-select-root')) return true;
    return !!(node.closest && node.closest('variant-swatch-king, [option-name], [data-option-name], .case-type-selector, .easify'));
  }

  function mutationsRelateToCaseType(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (nodeRelatesToCaseType(added[j])) return true;
      }
    }
    return false;
  }

  function scheduleCaseTitleFix() {
    if (caseTypeFixTimer) window.clearTimeout(caseTypeFixTimer);
    caseTypeFixTimer = window.setTimeout(function () {
      caseTypeFixTimer = null;
      injectCaseTitleFix();
      applyCaseTitleFix();
    }, 120);
  }

  function bootstrapCaseTitleFix() {
    cleanupEasifyModelSkeleton();
    injectCaseTitleFix();
    applyCaseTitleFix();
    initEasifyModelController();
    window.setTimeout(applyCaseTitleFix, 250);
    window.setTimeout(applyCaseTitleFix, 1000);
  }

  function init() {
    bootstrapCaseTitleFix();
    window.addEventListener('load', scheduleCaseTitleFix);
    document.addEventListener('shopify:section:load', scheduleCaseTitleFix);

    if (document.body) {
      new MutationObserver(function (mutations) {
        if (!mutationsRelateToCaseType(mutations)) return;
        scheduleCaseTitleFix();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  'use strict';

  function handleFilterClick(evt) {
    var link = evt.target.closest('.collection-filter-link');
    if (!link) return;

    var paramName = link.getAttribute('data-filter-param');
    var filterValue = link.getAttribute('data-filter-value');
    if (!paramName || !filterValue) return;

    var form = document.getElementById('CollectionFilterForm');
    if (!form) return;

    var checkbox = form.querySelector(
      'input[type="checkbox"][name="' + paramName + '"][value="' + CSS.escape(filterValue) + '"]'
    );
    if (!checkbox) return;

    evt.preventDefault();
    var willCheck = !checkbox.checked;

    form.querySelectorAll('input[type="checkbox"][name="' + paramName + '"]').forEach(function (cb) {
      cb.checked = false;
    });

    checkbox.checked = willCheck;

    var container = link.closest('.collection-listing, .collection-slider-row');
    if (container) {
      container.querySelectorAll('.collection-block').forEach(function (block) {
        block.classList.remove('collection-block--active');
      });
      if (checkbox.checked) {
        var clickedBlock = link.closest('.collection-block');
        if (clickedBlock) clickedBlock.classList.add('collection-block--active');
      }
    }
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', handleFilterClick);
})();
